export function formatDateTime(timestampInMs: number, showTime: boolean = true): string {
	const dateOptions: Intl.DateTimeFormatOptions = {
		day: '2-digit',
		month: '2-digit',
		year: '2-digit'
	}

	const timeOptions: Intl.DateTimeFormatOptions = {
		hour: '2-digit',
		minute: '2-digit',
		hour12: true
	}

	const date = new Intl.DateTimeFormat('en-GB', { ...dateOptions, ...(showTime ? timeOptions : {}) }).format(
		new Date(timestampInMs)
	)

	return date
}

/**
 * Formats a date to a string in the format of "Month Day" with the ordinal suffix.
 * @param date - The date to format.
 * @returns The formatted date string.
 */
export function formatMonthDayOrdinal(date: Date) {
	const day = date.getDate()
	const month = date.toLocaleDateString('en-US', { month: 'short' })

	return `${month} ${day}${getOrdinalSuffix(day)}`
}

export function getOrdinalSuffix(day: number): string {
	if (day >= 11 && day <= 13) return 'th'

	switch (day % 10) {
		case 1:
			return 'st'
		case 2:
			return 'nd'
		case 3:
			return 'rd'
		default:
			return 'th'
	}
}

export function parseToTimestamp(time: Date): number {
	if (!(time instanceof Date) || isNaN(time.getTime())) {
		throw new Error('Invalid time provided.')
	}

	return Math.floor(time.getTime() / 1000)
}
